import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "ss-tela-estrutura" }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_4 = { class: "ant-btn-group ss-grupo-recursos" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "Novo", -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "ss-card ss-card-space ss-alinhar-texto-esquerda" }
const _hoisted_8 = {
  key: 0,
  class: "acoes-item"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { key: 1 }
const _hoisted_12 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_titulo_padrao = _resolveComponent("titulo-padrao")!
  const _component_coluna_grade = _resolveComponent("coluna-grade")!
  const _component_icone = _resolveComponent("icone")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_simulacao_producao_modal = _resolveComponent("simulacao-producao-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_titulo_padrao, {
          identificadorRecurso: "PCP_SIMULACAO_PRODUCAO",
          tituloRecurso: "Simulações de Produção",
          empresasSelecionadas: [_ctx.state.empresaSelecionada]
        }, {
          BotoesAcoes: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("button", {
                type: "button",
                class: "ant-btn ant-btn-primary ss-btn-tela",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.incluir()))
              }, _hoisted_6)
            ])
          ]),
          _: 1
        }, 8, ["empresasSelecionadas"]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_a_table, {
            columns: _ctx.colunas,
            "data-source": _ctx.simulacoesFiltradasOrdenadas,
            rowKey: "codigo",
            pagination: false,
            loading: _ctx.telaBase.carregando,
            size: "small"
          }, {
            headerCell: _withCtx(({ column }) => [
              _createVNode(_component_coluna_grade, {
                column: column,
                ordenacaoSelecionada: _ctx.gradeBase.ordenacaoSelecionada,
                "onUpdate:ordenacaoSelecionada": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.gradeBase.ordenacaoSelecionada) = $event)),
                filtrosCabecalho: _ctx.gradeBase.filtrosCabecalho,
                "onUpdate:filtrosCabecalho": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.gradeBase.filtrosCabecalho) = $event)),
                onBuscarDados: _ctx.atualizarGradeCabecalho
              }, null, 8, ["column", "ordenacaoSelecionada", "filtrosCabecalho", "onBuscarDados"])
            ]),
            bodyCell: _withCtx(({ column, record, text }) => [
              (column.key === 'acoes')
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("a", {
                      class: "visualizar",
                      onClick: ($event: any) => (_ctx.editar(record.codigo))
                    }, [
                      _createVNode(_component_icone, { nome: "visualizar" })
                    ], 8, _hoisted_9),
                    _createElementVNode("a", {
                      onClick: ($event: any) => (_ctx.confirmarExclusao(record)),
                      class: "excluir"
                    }, [
                      _createVNode(_component_icone, { nome: "excluir" })
                    ], 8, _hoisted_10)
                  ]))
                : (column.key === 'dataSimulacao')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(text)), 1))
                  : (_openBlock(), _createElementBlock("a", {
                      key: 2,
                      onClick: ($event: any) => (_ctx.editar(record.codigo))
                    }, [
                      _createElementVNode("span", null, _toDisplayString(text), 1)
                    ], 8, _hoisted_12))
            ]),
            emptyText: _withCtx(() => [
              _createVNode(_component_mensagem_sem_dados, {
                resultadoPesquisa: !_ctx.telaBase.carregando,
                mensagem: _ctx.telaBase.carregando?'Buscando informações, por favor aguarde...':'Nenhuma simulação encontrada.'
              }, null, 8, ["resultadoPesquisa", "mensagem"])
            ]),
            _: 1
          }, 8, ["columns", "data-source", "loading"])
        ])
      ])
    ]),
    _createVNode(_component_simulacao_producao_modal, {
      operacao: _ctx.state.operacaoLancamento,
      visivel: _ctx.state.exibirModal,
      "onUpdate:visivel": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.exibirModal) = $event)),
      onConfirmacao: _cache[4] || (_cache[4] = ($event: any) => (_ctx.atualizarInformacoesTela()))
    }, null, 8, ["operacao", "visivel"])
  ]))
}